import React from 'react'
import { Panel } from 'primereact/panel'
import { Message } from 'primereact/message'

import { dateFormat, plusDate, convertDateMonthNumberToWord } from '../../utils/utilFunctions'

export const WasteNewView = ({ data }) => {
    data = data || []

    const criteriaShow = () => {
        let result = data.map((value) => {
            const {
                effective_start_date,
                effective_end_date,
                messages
            } = value

            let toDate = new Date();
            let endDate = dateFormat(effective_end_date) == "01/01/0001 00:00:00" ? plusDate(toDate, 1) : new Date(effective_end_date)
            let startDate = new Date(effective_start_date);

            let rs = (<div></div>);
            if (endDate >= toDate && startDate <= toDate) {
                rs = (
                    <li style={{ paddingLeft: 20 }}>
                        <span> <label style={{ color: 'green', fontWeight: 'bold' }}>ประกาศเมื่อวันที่ {convertDateMonthNumberToWord(startDate)}</label> : {messages}</span>
                    </li>
                )
            }

            return rs
        })
        return result;
    }

    return (
        <div className="p-grid">
            <div className="p-col-12">
                <Panel header="ข่าวสาร">
                    {data.length == 0 &&
                        <li style={{ paddingLeft: 20 }}>
                            <span>  เริ่มให้บริการ 1 มีนาคม 2563 เป็นต้นไป.</span>
                        </li>
                    }
                    {data.length > 0 &&
                        <li style={{ paddingLeft: 20 }}>
                            <span>{data[data.length-1].messages}</span>
                        </li>
                    }
                </Panel>
            </div>
        </div>
    )
}